import ApiService from '@/api/http/ApiService';
import { Page } from '@/interfaces/api/Page';
import { SyncJob } from '@/interfaces/models/SyncJob';
import axios, { AxiosPromise } from 'axios';

export default class SyncApiService extends ApiService<any> {
  constructor() {
    super('sync');
  }
  public index(page?: Page | null | undefined, filter?: any): AxiosPromise<SyncJob[]> {
    return axios.get(`${this.getBaseUrl()}/jobs`, {
      params: { page: page?.page, limit: page?.limit, ...filter, sortBy: 'createdAt', sortOrder: 'desc' },
    });
  }

  public sync(config: any): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/sync`, config);
  }

  public syncUpsells(config: any): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/sync/upsell`, config);
  }

  public stopSync(id: string): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/jobs/${id}/stop`);
  }

  public getItem(id: string): AxiosPromise<SyncJob> {
    return axios.get(`${this.getBaseUrl()}/jobs/${id}`);
  }

  public copyVenue(config: any): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/venue/copy`, config);
  }

  public copyVenueOnly(config: any): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/venue/copy/venue-only`, config);
  }
}
